(function () {
  'use strict';

  var MAKE_PARAM = 'filter.p.m.custom.car_make';
  var MODEL_PARAM = 'filter.p.m.custom.car_model';
  var UNIVERSAL_VALUE = 'Universal';
  var DESKTOP_QUERY = '(min-width: 990px)';

  var root = document.querySelector('[data-lcm-header-garage]');

  if (!root || root.dataset.lcmInitialized === 'true') {
    return;
  }

  root.dataset.lcmInitialized = 'true';

  var desktopMedia = window.matchMedia(DESKTOP_QUERY);
  var details = root.querySelector('details');
  var pickerMount = root.querySelector('[data-lcm-header-garage-picker]');
  var changeButton = root.querySelector('[data-lcm-header-garage-change]');
  var clearButton = root.querySelector('[data-lcm-header-garage-clear]');
  var pickerSource = null;
  var quickFilter = null;
  var retryCount = 0;
  var MAX_RETRIES = 100;
  var pickerObserver = null;
  var mountScheduled = false;

  function focusPicker() {
    var controls = pickerMount.querySelectorAll('.nice-select, select, button, [tabindex="0"]');
    var control = Array.prototype.find.call(controls, function (item) {
      return !item.disabled && item.getClientRects().length &&
        window.getComputedStyle(item).visibility !== 'hidden';
    });
    if (control) control.focus({ preventScroll: true });
  }

  function firstPage(url) {
    var parsed = new URL(url, window.location.origin);
    if (parsed.origin !== window.location.origin) return window.location.pathname;
    parsed.searchParams.delete('page');
    return parsed.pathname + parsed.search + parsed.hash;
  }

  function pickerMessage(message) {
    var status = root.querySelector('[data-lcm-garage-message]');
    if (status) status.textContent = message || '';
  }

  function scheduleMount() {
    if (mountScheduled) return;
    mountScheduled = true;
    window.requestAnimationFrame(function () {
      mountScheduled = false;
      if (desktopMedia.matches) mountPickerInGarage();
    });
  }


  function getVehicle() {
    if (
      !window.LCMVehicle ||
      typeof window.LCMVehicle.getActive !== 'function'
    ) {
      return undefined;
    }

    return window.LCMVehicle.getActive();
  }

  function getVehicleName(vehicle) {
    if (!vehicle) {
      return '';
    }

    return [vehicle.make, vehicle.model]
      .map(function (part) {
        return String(part || '').trim();
      })
      .filter(Boolean)
      .join(' ');
  }

  function findGlobalPickerSource() {
    if (
      pickerSource &&
      document.documentElement.contains(pickerSource)
    ) {
      return pickerSource;
    }

    pickerSource = document.querySelector(
      '.shopify-section-group-header-group ' +
      '[data-lcm-vehicle-picker-source]'
    );

    return pickerSource;
  }

  function rememberQuickFilter() {
    if (
      quickFilter &&
      document.documentElement.contains(quickFilter)
    ) {
      return quickFilter;
    }

    var source = findGlobalPickerSource();

    if (source) {
      quickFilter = source.querySelector(
        'quick-filter[data-mode="filter"]'
      );
    }

    // The central vehicle script may already have moved the global source.
    if (!quickFilter) {
      quickFilter = document.querySelector(
        '[data-lcm-vehicle-status] [data-lcm-vehicle-picker-mount] quick-filter[data-mode="filter"]'
      );
    }
    return quickFilter;
  }

  function mountPickerInGarage() {
    var filter = rememberQuickFilter();

    if (!filter || !pickerMount) {
      return false;
    }

    if (filter.parentNode !== pickerMount) {
      pickerMount.appendChild(filter);
    }

    pickerMessage('');
    return true;
  }

  function returnPickerToSource() {
    var source = findGlobalPickerSource();
    var filter = rememberQuickFilter();

    if (!source || !filter) {
      return;
    }

    if (filter.parentNode !== source) {
      source.appendChild(filter);
    }

    source.hidden = true;
    source.setAttribute('aria-hidden', 'true');
    source.style.setProperty('display', 'none', 'important');

    setPickerOpen(false);

    window.setTimeout(function () {
      window.dispatchEvent(
        new CustomEvent('lcm:vehiclechange', {
          detail: { reason: 'header-garage-responsive', activeVehicle: getVehicle() || null, garage: window.LCMVehicle && window.LCMVehicle.getGarage ? window.LCMVehicle.getGarage() : [] }
        })
      );
    }, 0);
  }

  function setPickerOpen(open) {
    if (!pickerMount || !changeButton) {
      return;
    }

    pickerMount.hidden = !open;
    root.classList.toggle('is-picker-open', open);
    changeButton.setAttribute('aria-expanded', String(open));
    changeButton.textContent = open
      ? changeButton.dataset.labelClose
      : changeButton.dataset.labelOpen;
  }

  function closeGarage() {
    setPickerOpen(false);

    if (details) {
      var hadFocus = root.contains(document.activeElement);
      details.open = false;
      if (hadFocus) root.querySelector('summary').focus({ preventScroll: true });
    }
  }

  function render() {
    var vehicle = getVehicle();

    if (typeof vehicle === 'undefined') {
      retryCount += 1;

      if (retryCount <= MAX_RETRIES) {
        window.setTimeout(render, 50);
      }

      return;
    }

    retryCount = 0;

    var emptyLabel = root.dataset.emptyLabel || 'Kies auto';
    var name = getVehicleName(vehicle) || emptyLabel;
    var triggerName = root.querySelector(
      '[data-lcm-header-garage-name]'
    );
    var panelName = root.querySelector(
      '[data-lcm-header-garage-panel-name]'
    );

    root.classList.toggle('has-vehicle', Boolean(vehicle));
    var summary = root.querySelector('summary');
    if (summary) summary.setAttribute('aria-label', root.dataset.garageLabel + ': ' + name);

    if (triggerName) {
      triggerName.textContent = name;
    }

    if (panelName) {
      panelName.textContent = name;
    }

    if (clearButton) {
      clearButton.hidden = !vehicle;
    }
  }

  function applyResponsiveLayout() {
    if (desktopMedia.matches) {
      mountPickerInGarage();
      if (!pickerObserver) {
        pickerObserver = new MutationObserver(scheduleMount);
        var source = findGlobalPickerSource();
        if (source) pickerObserver.observe(source, { childList: true, subtree: true });
        document.querySelectorAll('[data-lcm-vehicle-picker-mount]').forEach(function (mount) {
          pickerObserver.observe(mount, { childList: true });
        });
      }
      render();
      return;
    }

    closeGarage();
    returnPickerToSource();
  }

  function getSelectedVehicle(filter) {
    if (!filter) {
      return null;
    }

    var makeSelect = filter.querySelector('select[data-index="1"]');
    var modelSelect = filter.querySelector('select[data-index="2"]');

    if (!makeSelect || !modelSelect) {
      return null;
    }

    var make = String(makeSelect.value || '').trim();
    var model = String(modelSelect.value || '').trim();

    if (!make || !model || model === UNIVERSAL_VALUE) {
      return null;
    }

    var makeOption = makeSelect.options[makeSelect.selectedIndex];
    var modelOption = modelSelect.options[modelSelect.selectedIndex];

    if (
      !makeOption ||
      makeOption.getAttribute('data-filter-name') !== MAKE_PARAM ||
      !modelOption ||
      modelOption.getAttribute('data-filter-name') !== MODEL_PARAM
    ) {
      return null;
    }

    if (make.length > 120 || model.length > 120) return null;
    if (makeOption.disabled || modelOption.disabled) return null;
    return { make: make, model: model };
  }

  if (changeButton) {
    changeButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (!mountPickerInGarage()) {
        pickerMessage(root.dataset.messageUnavailable);
        return;
      }

      var shouldOpen = pickerMount.hidden;

      setPickerOpen(shouldOpen);

      if (shouldOpen) {
        window.setTimeout(function () {
          focusPicker();
        }, 0);
      }
    });
  }

  if (clearButton) {
    clearButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (
        window.LCMVehicle &&
        typeof window.LCMVehicle.deselect === 'function'
      ) {
        window.LCMVehicle.deselect({ reason: 'header-garage' });
      }

      closeGarage();

      if (
        window.LCMVehicle &&
        typeof window.LCMVehicle.isCollectionUrl === 'function' &&
        window.LCMVehicle.isCollectionUrl(window.location.href) &&
        typeof window.LCMVehicle.getUnfilteredCollectionUrl === 'function'
      ) {
        window.location.assign(
          firstPage(window.LCMVehicle.getUnfilteredCollectionUrl(
            window.location.href
          ))
        );
      }
    });
  }

  /*
   * De empty-state van collectiepagina's gebruikt nog de mobiele
   * .lcm-vehicle-status__change-knop. Die status is op desktop verborgen.
   * Onderschep uitsluitend die desktopactie en open de globale Garage.
   */
  window.addEventListener(
    'click',
    function (event) {
      var emptyStateButton = event.target.closest(
        '[data-lcm-empty-action="change-vehicle"]'
      );

      if (!emptyStateButton || !desktopMedia.matches) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!mountPickerInGarage()) {
        pickerMessage(root.dataset.messageUnavailable);
        return;
      }

      // A collection action can be clicked while the menu is hidden on scroll.
      var header = root.closest('.section-header');
      if (header) {
        header.classList.remove('shopify-section-header-hidden', 'scrolling-down');
        header.classList.add('scrolling-up');
      }
      window.scrollTo({ top: 0, behavior: 'instant' });
      if (details) {
        details.open = true;
      }

      setPickerOpen(true);

      window.setTimeout(function () {
        focusPicker();
      }, 0);
    },
    true
  );

  window.addEventListener(
    'click',
    function (event) {
      var submitButton = event.target.closest(
        '[data-lcm-header-garage] ' +
        'quick-filter[data-mode="filter"] .js-filter-submit'
      );

      if (!submitButton) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var filter = submitButton.closest(
        'quick-filter[data-mode="filter"]'
      );
      var vehicle = getSelectedVehicle(filter);

      if (!vehicle) {
        pickerMessage(root.dataset.messageChoose);
        focusPicker();
        return;
      }
      if (!window.LCMVehicle || typeof window.LCMVehicle.select !== 'function') {
        pickerMessage(root.dataset.messageUnavailable);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (
        window.LCMVehicle &&
        typeof window.LCMVehicle.select === 'function'
      ) {
        window.LCMVehicle.select(vehicle, {
          reason: 'header-garage'
        });
      }

      closeGarage();

      if (
        window.LCMVehicle &&
        typeof window.LCMVehicle.isCollectionUrl === 'function' &&
        window.LCMVehicle.isCollectionUrl(window.location.href) &&
        typeof window.LCMVehicle.getFilteredCollectionUrl === 'function'
      ) {
        window.location.assign(
          firstPage(window.LCMVehicle.getFilteredCollectionUrl(
            window.location.href,
            vehicle
          ))
        );
      } else {
        render();
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    if (
      details &&
      details.open &&
      !root.contains(event.target)
    ) {
      closeGarage();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !details || !details.open) {
      return;
    }

    closeGarage();

    var summary = root.querySelector('summary');

    if (summary) {
      summary.focus();
    }
  });

  window.addEventListener('lcm:vehiclechange', function () {
    render();
    scheduleMount();
  });

  if (typeof desktopMedia.addEventListener === 'function') {
    desktopMedia.addEventListener('change', applyResponsiveLayout);
  } else {
    desktopMedia.addListener(applyResponsiveLayout);
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(applyResponsiveLayout, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      applyResponsiveLayout,
      { once: true }
    );
  } else {
    applyResponsiveLayout();
  }
})();